import { Pipe, PipeTransform } from '@angular/core';
import { TenantFilterDto } from '@artemis-software/wr-api';
import FacilityElementEnum = TenantFilterDto.FacilityElementEnum;

export const facilityElementTranslations: Record<FacilityElementEnum, string> = {
  ABLESEUNTERNEHMEN: 'Ableseunternehmen',
  ANLAGE: 'Anlage',
  AUFZUG: 'Aufzug',
  AUTOPARKSYSTEM: 'Autoparksystem',
  BM_ANLAGE: 'BM Anlage',
  BAUM_UND_STRAUCHSCHNITT: 'Baum- und Strauchschnitt',
  BAUMEISTER: 'Baumeister',
  BRAND_UND_WASSERSCHADENSANIERUNG: 'Brand- und Wasserschadensanierung',
  BRANDSCHUTZBEAUFTRAGTER: 'Brandschutzbeauftragter',
  BRANDSCHUTZKLAPPE: 'Brandschutzklappe',
  BRANDSCHUTZTOR: 'Brandschutztor',
  CO_WARNANLAGE: 'CO-Warnanlage',
  DACHDECKER: 'Dachdecker',
  ELEKTRIKER: 'Elektriker',
  ENTRUEMPELUNG: 'Entrümpelung',
  FENSTER: 'Fenster',
  FEUERLOESCHER: 'Feuerlöscher',
  FLIESENLEGER: 'Fliesenleger',
  GARAGENTOR: 'Garagentor',
  GASTHERME: 'Gastherme',
  GEWAEHRLEISTUNG: 'Gewährleistung',
  GLASEREI: 'Glaserei',
  GRUENFLAECHENBETREUUNG: 'Grünflächenbetreuung',
  HAUSBETREUUNG: 'Hausbetreuung',
  HEIZANLAGE: 'Heizanlage',
  INSTALLATEUR: 'Installateur',
  KAMINSANIERUNG: 'Kaminsanierung',
  KANALVERSTOPFUNG_KAMERA: 'Kanalverstopfung + Kamera',
  KLEINREPARATUR: 'Kleinreparatur',
  MALER: 'Maler',
  NASSSTEIGLEITUNG: 'Nasssteigleitung',
  NEU: 'Neu',
  RWA_ANLAGE: 'RWA Anlage',
  RAUCHFANGKEHRER: 'Rauchfangkehrer',
  SALZ_UND_DOSIERUNG: 'Salz und Dosierung',
  SCHLOSSER: 'Schlosser',
  SCHRANKENANLAGE: 'Schrankenanlage',
  SCHAEDLINGSBEKAEMPFUNG: 'Schädlingsbekämpfung',
  SONNENSCHUTZ: 'Sonnenschutz',
  SPENGLER: 'Spengler',
  SPIELGERAETE_WARTUNG_REPARATUR: 'Spielgeräte Wartung & Reparatur',
  TISCHLER: 'Tischler',
  TROCKENSTEIGLEITUNG: 'Trockensteigleitung',
  WASCHKUECHE_GERAET: 'Waschküche Gerät',
  WASCHKUECHE_ZAEHLER: 'Waschküche Zähler',
  WASSERAUFBEREITUNG: 'Wasseraufbereitung',
  WINTERDIENST: 'Winterdienst',
  WOHNRAUMLUEFTUNG: 'Wohnraumlüftung',
};

@Pipe({
  name: 'facilityElementTranslation',
  standalone: false,
})
export class FacilityElementTranslationPipe implements PipeTransform {
  transform(value?: FacilityElementEnum): string | undefined {
    return value ? facilityElementTranslations[value] : undefined;
  }
}
